import React from "react";
import { create } from "jss";
import { Provider } from "react-redux";
import { Navigate, useNavigate, useRoutes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "styled-components/macro";
import { HelmetProvider, Helmet } from "react-helmet-async";

import jssPreset from "@mui/styles/jssPreset";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import StylesProvider from "@mui/styles/StylesProvider";
import { StyledEngineProvider } from "@mui/styled-engine-sc";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

import "./i18n";
import routes from "./routes";
import createTheme from "./theme";
import { store } from "./redux/store";
import useTheme from "./hooks/useTheme";
import { AuthProvider } from "./contexts/JWTContext";

import authTokenUtils from '../src/utils/AuthTokenUtils'
import { useEffect } from "react";


const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point"),
});



function App() {
  const content = useRoutes(routes);
  const { theme } = useTheme();

  const navigate = useNavigate()


  useEffect( () => {
    authTokenUtils()
    .then( (res) => {
      console.log(res)
      if(!res.data.success){
        window.location.href = "https://prwire360.com/auth/login";
      }
    })
    
  })


  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | PRWIRE"
        defaultTitle="Prwire Portal - Support Dashboard"
      />

      <Provider store={store}>
        <StylesProvider jss={jss}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StyledEngineProvider injectFirst>
              <MuiThemeProvider theme={createTheme(theme)}>
                <ThemeProvider theme={createTheme(theme)}>
                  <AuthProvider>{content}</AuthProvider>
                  <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </ThemeProvider>
              </MuiThemeProvider>
            </StyledEngineProvider>
          </LocalizationProvider>
        </StylesProvider>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
